var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatePicker = function SvgDatePicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "8 8 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.127,
    d: "M12.882 12.104V8.987m6.234 3.117V8.987m-7.013 6.234h7.792m-9.35 7.792h10.908c.861 0 1.559-.698 1.559-1.559v-9.35c0-.86-.698-1.558-1.559-1.558H10.545c-.861 0-1.559.697-1.559 1.558v9.35c0 .861.698 1.559 1.559 1.559"
  })));
};
export default SvgDatePicker;